<span class="sos-link {{font_weight}} {{type}}-link {{size}}">
    <ng-content></ng-content>
</span>
